import { palette } from './palette';

export const homeStyle = {
  /* Global Button Styles */
  '& .MuiButton-root': {
    padding: '9px 20px !important',
    minHeight: '48px !important',
    height: 'fit-content !important',
    fontWeight: '400 !important',
    fontFamily: '"Libre Franklin", sans-serif !important',
    fontSize: '16px !important',
  },
  /* Exclude navbar navigation buttons from global padding */
  '.header-wrapper ': {
    '& .MuiButton-root': {
      padding: '9px 10px !important',
    },
    '& .MuiButton-containedPrimary' :{
      padding: '9px 16px !important',
    },
    '& .menu-item': {
      marginRight: '10px !important',
    },
  },

  /* Subscription Success Card */
  '& .success-wrapper': {
    marginTop: '100px !important',
  },

  /* Payment Dialog Loader */
  '& .progressLoad': {
    color: `${palette.text.highlight} !important`,
  },

  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  /* Nav sidebar (MFE) uses a modal Drawer portaled to body — not under .colosseum-container. */
  '.sidebar-drawer-signup-row': {
    display: 'none !important',
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',

      '& .hero-shaped__right-side': {
        '@media(max-width: 500px)': {
          maxWidth: '95vw !important',
        },
      },

      '& .logo-image': {
        height: 46,
      },
      '& .section-header__title': {
        fontFamily: '"DM Serif Text", serif !important',
      },

      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',
        '& .hero-shaped__image': {
          width: '50vw',
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    fontFamily: '"Libre Franklin", sans-serif !important',
    '& .MuiToolbar-root': {
      minHeight: '72px',
      '& .top-bar-logo-container': {
        paddingInline: '0px !important',
        '& img': {
          maxWidth: '200px',
        },
      },

      '& .topbar-list': {
        '& .topbar-listitem': {
          padding: '0px 0px !important',
          '& .MuiButton-root': {
            '& .MuiTypography-root': {
              transition: 'color 0.2s ease', // smooth transition for color change
              fontFamily: '"Libre Franklin", sans-serif !important',
            },
            '&:hover': {
              '& .MuiTypography-root': {
                color: palette.secondary.main, // nav link hover
              },
            },
          },
        },
        /* Login nav: match Get Started (MuiButton-containedPrimary) padding + primary fill */
        '& .topbar-listitem[aria-label="Login"] .MuiButton-root': {
          marginLeft: '50px !important',
          padding: '9px 16px !important',
          minHeight: '48px !important',
          height: 'fit-content !important',
          backgroundColor: `${palette.secondary.main} !important`,
          color: `${palette.primary.contrastText} !important`,
          boxShadow:
            '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important',
          '&:hover': {
            backgroundColor: `${palette.primary.main} !important`,
            boxShadow:
              '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12) !important',
          },
          '& .MuiTypography-root': {
            color: `${palette.primary.contrastText} !important`,
            marginRight: '0 !important',
          },
        },
      },
    },
    /* Topbar Sign up (wide + mid breakpoints); .topbar-signup-cta is on the signup Button only (not Logout). */
    '& .menu-item--no-dropdown': {
      display: 'none !important',
    },
    '& .topbar-signup-cta': {
      display: 'none !important',
    },
  },

  '.colosseum-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },


    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .dashboard-hero-section':
    {
      backgroundColor: palette.primary.main,
      color: palette.text.highlight,
      marginTop: 88,

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
      '& .hero-header-title': {
        fontFamily: '"DM Serif Text", serif !important',
        fontSize: '32px !important',
      },
      '& .hero-home-button': {
        background: palette.text.highlight,
        color: palette.text.primary,
        fontFamily: 'Inter Display !important',
        '&:hover': {
          background: palette.text.highlight,
        },
        border: 'none !important',
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      '& .home-hero-title': {
        color: `${palette.primary.main} !important`,
        fontSize: 'clamp(36px, 5vw, 48px) !important',
        lineHeight: 1.15,
        fontWeight: 500,
        '& .hero-tagline': {
          color: `${palette.primary.main} !important`,
          fontFamily: '"DM Serif Text", serif !important',
          fontSize: 'inherit !important',
          lineHeight: 'inherit',
          fontWeight: 'inherit',
          display: 'inline',
        },
        '& .header-text': {
          color: `${palette.secondary.main} !important`,
          fontFamily: '"DM Serif Text", serif !important',
          fontSize: 'inherit !important',
          lineHeight: 'inherit',
          fontWeight: 'inherit',
          display: 'inline',
        },
        '@media(max-width: 1024px)': {
          fontSize: '44px !important',
          textAlign: 'center',
          maxWidth: '100% !important',
        },
        '@media(max-width: 900px)': {
          fontSize: '32px !important',
        },
      },
      '& .section-header__subtitle-wrapper': {
        maxWidth: 550,
      },
      '& .hero-section': {
        '& .section-header__cta-wrapper': {
          '& .MuiButton-containedSecondary': {
            background: `${palette.text.highlight} !important`,
            color: `${palette.text.primary} !important`,
            border: `solid 1.2px ${palette.secondary.main}!important`,
            transition: 'background-color 0.3s ease',
            '&:hover': {
              backgroundColor: `${palette.surface.grey} !important`,
            },
          }
        }

      },
      marginTop: 88,
      backgroundColor: palette.background.secondary,
      '& .section-alternate__content': {
        '@media(min-width: 1025px)': {
          paddingBottom: 0,
        },
      },

      '& .hero-background': {
        objectFit: 'cover',
        '@media(max-width: 1024px)': {
          position: 'static !important',
          width: '100% !important',
          height: 'auto !important',
          content: 'url(/images/home-images/home-banner-img-mobile.webp) !important',
        },
      },

      '& .secondary-button': {
        background: palette.background.alternate,
        fontFamily: 'Inter Display !important',
        color: '#22211F',
        border: 'none',
        '&:hover': {
          background: palette.secondary.main,
        },
      },
      '& .MuiButton-containedPrimary': {
        fontFamily: 'Inter Display',
        backgroundColor: `${palette.secondary.main} !important`,
        color: palette.text.highlight,
      },
      '& .section-header__title': {
        fontFamily: '"DM Serif Text", serif !important',
        maxWidth: '560px !important',
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          maxWidth: 500,
          lineHeight: '55px',
          fontFamily: '"DM Serif Text", serif !important',

          '@media(min-width: 1025px)': {
            lineHeight: '80px',
          },
          '@media(max-width: 1024px)': {
            textAlign: 'center',
            fontSize: '32px !important',
          },
        },
        '& .hero-subtitle': {
          maxWidth: 450,
          color: palette.text.primary,
          '@media(max-width: 1024px)': {
            textAlign: 'center',
          },
        },
      },
      '& .image-wrapper': {
        '@media(max-width: 1024px)': {
          backgroundImage: `linear-gradient(90deg, ${palette.background.secondary} 16%, ${palette.background.main} 0%)`,
          padding: '24px 48px 24px 16px',
        },
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
      },
      '& .section-header__cta-container': {
        '@media(max-width: 1024px)': {
          justifyContent: 'center !important',
          flexWrap: 'wrap',
        },
      },

      /* HeroVariant2 — single-column centered layout up to 1024px */
      '@media(max-width: 1024px)': {
        '& .hero-section .MuiGrid-grid-md-6': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
        '& .hero-section .section-header': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .section-header__title-wrapper': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .section-header__title-wrapper .MuiTypography-root': {
          textAlign: 'center !important',
        },
        '& .section-header__subtitle-wrapper': {
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
        },
        '& .section-header__subtitle-wrapper .MuiTypography-root': {
          textAlign: 'center !important',
        },
        '& .section-header__overline-wrapper': {
          justifyContent: 'center !important',
        },
        /* SectionHeader CTA Grid is sm={8} — full width + centered row */
        '& .section-header__cta-wrapper': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
          marginLeft: '0 !important',
        },
        '& .section-header__cta-item-wrapper': {
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          alignItems: 'center',
          columnGap: '16px',
          rowGap: '12px',
          width: '100%',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .section-header__title': {
        textAlign: 'center',
      },

      '@media(max-width: 900px)': {
        '& .section-header__title': {
          textAlign: 'center',
        },
        '& .definition-service-title': {
          textAlign: 'center',
          color: '#141B22 !important',
        },
      },
      '& .benefits-wrapper': {
        '@media(min-width: 1200px)': {
          '& .section-header': {
            paddingBottom: 0,
            marginBottom: "32px",
          },
        },

        '& .section-header__subtitle': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
          fontWeight: 400,
          color: '#697883 !important',
          textAlign: 'center',
          marginBottom: '22px !important',
        },

        '& .section-header__title': {
          textAlign: 'center',
        },

        '& img, & .icon, & .icon-image': {
          height: '64px !important',
          width: '64px !important',
        },
      },

      '& .section-header__title': {
        fontFamily: '"DM Serif Text", serif !important',
        color: '#141B22 !important',
        '@media(max-width: 900px)': {
          textAlign: 'center',
        },
      },

      '& .section-header': {
        '@media(min-width: 900px)': {
          paddingBottom: 50,
        },
      },

      '& .section-alternate__content': {
        '@media(min-width: 900px)': {
          paddingLeft: 48,
          paddingRight: 48,
        },
        '@media(max-width: 899px)': {
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
      '& .definition-service-tile': {
        '& .definition-service-description-wrapper': {
          maxWidth: 350,
        },
        '& .definition-service-innertile': {
          border: `1px solid ${palette.text.border}`,
          borderRadius: 12,
          padding: '15px',
          height: '100%',
          '& .definition-service-title': {
            color: '#141B22 !important',
            fontSize: '24px !important',
            fontFamily: '"DM Serif Text", serif !important',
          },
          '& .definition-service-description': {
            paddingBottom: 10,
            fontSize: '16px !important',
            lineHeight: '22px !important',
            fontFamily: '"Libre Franklin", sans-serif !important',
            textAlign: 'center',
          },
          '@media (max-width: 767px)': {
            '& .definition-service-description': {
              textAlign: 'center',
              borderBottom: `1px solid ${palette.divider}`,
            },
          },
        },
      },
    },

    /* Find a location (embedded on home, after benefits) */
    '& .find-provider-home-embed': {
      backgroundColor: palette.background.level2,
      position: 'relative',
      overflow: 'hidden',
      paddingTop: 48,
      paddingBottom: 56,
      '&::after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: -180,
        right: -30,
        width: 634,
        height: 780,
        backgroundImage: 'url(/images/home-images/uk-map.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        opacity: 0.45,
        pointerEvents: 'none',
        zIndex: 0,
        isolation: 'isolate',
        '@media(max-width: 900px)': {
          display: 'none',
        },
      },
      '@media(max-width: 900px)': {
        paddingTop: 32,
        paddingBottom: 40,
      },
      '& .checkout-flow-main-container': {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: 'none',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: 24,
        paddingRight: 24,
        '@media(min-width: 900px)': {
          paddingLeft: 48,
          paddingRight: 48,
        },
      },
      '& .checkout-flow-main-container > header': {
        maxWidth: 1600,
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: 16,
        paddingRight: 16,
        '@media(min-width: 600px)': {
          paddingLeft: 64,
          paddingRight: 64,
        },
      },
      '& .checkout-flow-main-container > header h2': {
        fontFamily: '"DM Serif Text", serif !important',
        color: palette.text.primary,
        textAlign: 'left',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        position: 'unset',
      },
      '@media(max-width: 900px)': {
        '& .subscription-bg': {
          position: 'unset',
        },
      },
      background: palette.background.subscription,
      '& .section-header__title, .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
      {
        color: `${palette.text.highlight} !important`,
      },
      '& .subscription-tabs-label': {
        fontSize: '14px !important',
      },
      '& .summary-text': {
        fontWeight: 400,
        '@media(max-width: 500px)': {
          fontSize: '3.45vw !important',
          marginTop: '0px !important',
        },
      },
      '& .summary-subtext': {
        '@media(max-width: 500px)': {
          fontSize: '2.9vw !important',
        },
      },
      '& #pricing-benefit-section': {
        '& .section-header__title': {
          fontFamily: '"DM Serif Text", serif !important',
        },
        '& .section-header__subtitle': {
          fontFamily: '"Libre Franklin", sans-serif !important',
          fontWeight: '400 !important',
          fontSize: '20px !important',
        },
        '& .section-alternate__content': {
          '@media(min-width: 900px)': {
            paddingLeft: 48,
            paddingRight: 48,
          },
          '@media(max-width: 899px)': {
            paddingLeft: 24,
            paddingRight: 24,
          },
        },
        '& .planCard': {
          border: `1px solid ${palette.text.highlight}`,
          '& .customcardTitle': {
            fontFamily: '"DM Serif Text", serif !important'
          },
          '&:hover': {
            border: `1px solid ${palette.secondary.main}`,
            color: palette.text.primary,
            background: `${palette.text.highlight} !important`,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-containedPrimary': {
            '&:hover': {
              opacity: 1,
              backgroundColor: palette.secondary.main,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 620,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: palette.secondary.main,
      },
      '& .MuiSwitch-track': {
        borderColor: palette.secondary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked': {
        borderColor: palette.background.primary,
        '& .MuiSwitch-thumb': {
          borderColor: palette.secondary.main,
          backgroundColor: palette.primary.main,
        },
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        borderColor: palette.primary.main,
        backgroundColor: `${palette.text.highlight} !important`,
      },
    },

    '& .section-header__subtitle, & .section-alternate__content p, & .subscription-content': {
      fontFamily: '"Libre Franklin", sans-serif !important',
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      '& .section-header__title': {
        fontFamily: '"DM Serif Text", serif !important',
      },
      '& .section-header__subtitle': {
        fontSize: '20px !important',
      },
      '& section': {
        '& .howitworks-wrapper': {
          '@media(min-width: 900px)': {
            paddingLeft: 48,
            paddingRight: 48,
          },
          '@media(max-width: 899px)': {
            paddingLeft: 24,
            paddingRight: 24,
          },
        },
      },
      background: palette.alternate.light,
      '& .howitworks-wrapper': {
        '& .how-cover-image': {
          height: 'auto',
        },
      },
      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
        marginBottom: 0,
        borderBottom: `1px solid ${palette.text.disabled}`,
      },
      '& .step-title': {
        fontSize: '24px !important',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: '-0.48px',
        color: '#22211F',
        fontFamily: '"DM Serif Text", serif !important',
        marginBottom: '-12px !important',
      },
      '& .step-content': {
        fontSize: '16px !important',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '22px !important',
        letterSpacing: '-0.32px',
        fontFamily: '"Libre Franklin", sans-serif !important',
      },
      '& .how-it-works-image': {
        borderRadius: 12,
        '@media(max-width: 1024px)': {
          height: '240px',
        },
        '@media(max-width: 500px)': {
          height: '380px',
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      paddingBottom: 80,
      '& .section-alternate': {
        borderBottom: `1px solid ${palette.text.disabled}`,
      },

      '& .section-header__overline-wrapper': {
        color: palette.primary.main,
      },

      '& .testimonial-title-wrapper': {
        '& .section-header__title': {
          maxWidth: 500,
        },
      },
      '& .testimonial-container': {
        flexDirection: 'column-reverse',

        '@media(min-width: 900px)': {
          flexDirection: 'row-reverse',
        },
      },
      '& .testimonial-content-wrapper': {
        marginTop: 10,
        '@media(min-width: 900px)': {
          marginTop: -200,
        },

        '& .react-multi-carousel-track': {
          paddingTop: 60,
          '@media(min-width: 900px)': {
            paddingTop: 200,
          },
        },
        '& .custom-arrow': {
          border: 0,
          backgroundColor: 'unset',
          top: 0,
          width: 40,
          height: 40,
        },
        '& .left-arrow': {
          right: 75,
          left: 'unset',
        },
        '& .testimonial-message': {
          color: palette.text.primary,
          fontFamily: 'OpenSauceSans',
          fontWeight: 400,
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '@media(min-width: 900px)': {
          justifyContent: 'left',
        },

        '& .image': {
          height: '100%',
          width: 'auto',

          '@media(min-width: 900px)': {
            height: 414,
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.surface.grey,
      },
      '& .section-header__title': {
        fontFamily: '"DM Serif Text", serif !important',
      },
      '& .hero-static-section': {
        backgroundColor: palette.background.footer,

        '& .section-alternate__content': {
          padding: '48px 24px !important',
          '@media(min-width: 900px)': {
            padding: '48px 48px !important',
          },
        },

        '& .section-header__title': {
          color: palette.text.primary,
          maxWidth: 600,
        },
        '& .section-header__subtitle': {
          color: palette.text.muted,
        },
        '& .primary-static-button': {
          backgroundColor: palette.secondary.main,
          color: `${palette.text.highlight} !important`,
        },
      },
    },

    /* Savings Summary */
    '& .savings-header': {
      color: '#141B22 !important',
    },
    '& .savings-wrapper': {
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.background.main,
        fontWeight: 600,
      },
      '& .savings-hero-section': {
        fontFamily: '"DM Serif Text", serif !important',
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, & .faq-hero-section':
    {
      backgroundColor: palette.primary.main,
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .MuiSwitch-thumb': {
        backgroundColor: palette.secondary.main,
      },
      '& .MuiSwitch-track': {
        borderColor: palette.secondary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked': {
        borderColor: palette.background.primary,
        '& .MuiSwitch-thumb': {
          borderColor: palette.secondary.main,
          backgroundColor: palette.primary.main,
        },
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        borderColor: palette.secondary.main,
        backgroundColor: `${palette.text.highlight} !important`,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
        '& .customEditButton': {
          padding: '0px !important',
        },
      },
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
          background: `${palette.text.highlight} !important`,
        },
      },
    },
    /* Provider Cards - Apply Libre Franklin to all provider card text */
    '& .card-wrapper, & .cardRoot, & .providerWrapper': {
      fontFamily: '"Libre Franklin", sans-serif !important',
      '& *': {
        fontFamily: '"Libre Franklin", sans-serif !important',
      },
      '& .MuiTypography-root, & .MuiCardContent-root, & .MuiList-root, & .MuiListItem-root, & .MuiListItemText-root': {
        fontFamily: '"Libre Franklin", sans-serif !important',
      },
      '& .MuiListItemAvatar-root': {
        alignSelf: 'flex-start !important',
        marginTop: '6px !important',
      },
    },
    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.footer,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },

    /* Footer Disclosure */
    '& .footer-wrapper': {
      paddingLeft: '40px !important',
      paddingRight: '40px !important',
      backgroundColor: palette.primary.main,
      fontSize: '14px !important',

      '&> .MuiGrid-item': {
        paddingInline: '0px !important',
      },
      /* FooterVariant2 CTA row (first direct grid item) */
      '& > .MuiGrid-item:first-of-type': {
        borderBottom: 'none !important',
      },
      /* Must match patient-portal-mfe FOOTER_SUBSCRIBILI_LOGO_CLASSNAME */
      '& .mfe-footer-subscribili-logo': {
        display: 'none !important',
      },
      '& *': {
        fontSize: '14px !important',
      },
      '& h2': {
        fontSize: '1.5625rem !important',
        lineHeight: '1.235 !important',
        fontFamily: '"DM Serif Text", serif !important',
        fontWeight: '400 !important',
        maxWidth: '350px',
        '@media (min-width: 600px)': {
          fontSize: '1.7219rem !important',
        },
        '@media (min-width: 900px)': {
          fontSize: '1.9243rem !important',
        },
        '@media (min-width: 1200px)': {
          fontSize: '2.125rem !important',
        },
      },
      '& h2 ~ p': {
        maxWidth: '350px',
      },
      '& .footer-signup-subtitle': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        fontFamily: '"Libre Franklin", sans-serif !important',
      },
      '& .footer-signup-button': {
        backgroundColor: `${palette.background.paper} !important`,
        color: `${palette.text.primary} !important`,
        '&:hover': {
          backgroundColor: `${palette.background.paper} !important`,
          color: `${palette.text.primary} !important`,
        },
      },
    },
    '& .footer-wrapper, & .footer-wrapper a': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
      fontSize: '14px !important',
    },

    /* Home Page FAQ Section - Custom accordion icons */
    '& .faq-variant2-wrapper': {
      '& .accordion__item-wrapper': {
        backgroundColor: `${palette.background.tableAlternate} !important`,
      },
      '& .accordion__collapsable-text': {
        color: `${palette.text.secondary} !important`,
      },
      '& .MuiAccordionSummary-expandIcon': {
        transform: 'none !important',
      },
      '& .expandIcon, & .collapseIcon': {
        color: 'transparent !important',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        width: '44px !important',
        height: '36px !important',
      },
      '& .expandIcon': {
        backgroundImage: 'url(/images/home-images/faq/home_faq_inactive_icon.svg)',
      },
      '& .collapseIcon': {
        backgroundImage: 'url(/images/home-images/faq/home_faq_active_icon.svg)',
      },
    },

    /* FAQ */
    '& .faq-contact-wrapper': {
      backgroundColor: palette.background.footer,
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          backgroundColor: palette.background.tableHead,
          color: `${palette.text.highlight} !important`,
        },
      },
      '& .savingsDataContainer': {
        '& .MuiGrid-grid-md-12': {
          '@media(min-width: 900px)': {
            flexGrow: 0,
            maxWidth: '66.666667%',
            flexBasis: '66.666667%',
          },
        },
      },
    },
    '& .faq-contact-section': {
      backgroundColor: palette.surface.grey,
      '@media(max-width: 500px)': {
        padding: '32px !important',
      },
    },
    '& .savings-contact-card': {
      padding: '0px 60px !important',
      backgroundColor: palette.surface.grey,
    },
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        // Still have questions section styling
        '& .contact-card-title': {
          fontFamily: '"DM Serif Text", serif !important',
        },
        '& .contact-card-subtitle': {
          color: '#4A5462 !important',
          fontFamily: '"Libre Franklin", sans-serif !important',
        },
        '& .contact-detail-label, & .contact-detail-heading': {
          color: '#4A5462 !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        '@media(max-width: 900px)': {
          fontSize: 'inherit !important',
        },

        '& .provider-contact-link, & .contact-detail-value': {
          color: '#000000 !important',
        },
      },
    },

    // All hero header titles and subtitles styling
    '& .hero-header-title': {
      fontFamily: '"Libre Franklin", sans-serif !important',
    },
    '& .hero-header-subtitle': {
      fontFamily: '"Libre Franklin", sans-serif !important',
      fontSize: '18px !important',
    },

    // Hero section subtitle styling
    '& .hero-subtitle': {
      color: palette.text.primary,
      fontFamily: '"Libre Franklin", sans-serif !important',
      fontSize: '18px !important',
      maxWidth: '450px !important',
    },

    // All buttons styling
    '& .MuiButton-root, & button': {
      fontFamily: '"Libre Franklin", sans-serif !important',
      fontWeight: '400 !important',
      fontSize: '16px !important',
      whiteSpace: 'nowrap !important',
      '@media (max-width: 1024px)': {
        whiteSpace: 'normal !important',
        textAlign: 'center !important',
        fontSize: '14px !important',
      },
    },

    // Navbar text styling
    '& .MuiAppBar-root, & .navbar, & .nav, & .navigation': {
      fontFamily: '"Libre Franklin", sans-serif !important',
      '& *': {
        fontFamily: '"Libre Franklin", sans-serif !important',
      },
    },

    '& .faq-wrapper': {
      '& .faqInnerContainer': {
        '& .MuiTabs-root': {
          '& .faq-link': {
            '@media(max-width: 500px)': {
              paddingLeft: '10px !important',
              marginRight: '15px !important',
            },
          },
          '& .MuiButton-label': {
            whiteSpace: 'nowrap !important',
          },
          '& .MuiTab-root': {
            '&.Mui-selected': {
              backgroundColor: palette.surface.grey,
              color: palette.text.primary,
              borderRadius: '4px',
            },
            '&:hover': {
              color: palette.text.primary,
            },
          },
        },
        '& .accorion__item-title-container, & h3': {
          fontWeight: 400,
          color: '#22211F',
          fontSize: '18px',
          fontFamily: '"Libre Franklin", sans-serif !important',
          fontStyle: 'normal',
          lineHeight: '24px',
          letterSpacing: '-0.36px',
        },

        '& .accordion__collapsable-text': {
          fontWeight: 300,
          fontSize: '14px',
          fontStyle: 'normal',
          color: '#4A5462',
          fontFamily: '"Libre Franklin", sans-serif !important',
          lineHeight: '20px',
          letterSpacing: '-0.28px',
        },
      },
    },

    '& .footer-bar': {
      backgroundColor: palette.background.footer,
    },

    '& .footer-bar-text': {
      color: palette.text.primary,
      fontSize: '14px !important',
    },

    '& .copyrights-footer-link': {
      padding: '16px 0px !important',
    },

    /* Copyrights Footer Button Styling */
    '& .copyrights-footer .MuiButton-root, & .copyrights-footer button': {
      color: 'white !important',
      padding: '16px 0 16px 20px !important',
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      /* Promo Code Text Styling */
      '& .promoToggle, & .customPromoToggle': {
        color: `${palette.secondary.main} !important`,
        cursor: 'pointer !important',
        textDecoration: 'underline !important',
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .stepperIconActive': {
        border: 'none !important',
      },
    },

    '& .privacy-policy-container, & .terms-conditions-container, & .patient-privacy-policy-container': {
      maxWidth: '1060px !important',
    },

  },
};
